<template>
  <div>
    <!-- <swiper :options="swiperOption" ref="mySwiper"> -->
    <!-- <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p21-2.jpg"
              width="100%"
              alt="蓝鲨 Robor 指纹启动"
            />
          </div>
          <div class="text t21">
            <div class="content">
              用指纹即可解锁并启动整车，彻底告别忘带钥匙的困扰。
            </div>
          </div>
          <div class="text fs_content t21a">指纹启动</div>
        </div>
      </swiper-slide> -->
    <!-- <swiper-slide> -->
    <div class="swiper">
      <div class="pic">
        <img
          src="/static/img/p21-1-ch.jpg"
          width="100%"
          alt="蓝鲨 Robor PKE无钥匙感应器"
        />
      </div>
      <div class="text t21">
        <div class="content aniel" :class="{ ani2: a1 }">
          驾驶这样⼀样汽⻋科技的集⼤成者，我们希望你得到⾮同凡响的体验。随身携带⼿机或蓝⽛遥控器，靠近⻋辆即可⾃动感应识别，实现⼀键启动；<br />刹停后只需放下侧撑，远离⻋辆即⾃动锁定。
        </div>
      </div>
      <div class="text fs_content t21a">蓝⽛智能钥匙</div>
    </div>
    <!-- </swiper-slide> -->
    <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    <!-- </swiper> -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      a1: false,
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    startani() {
      this.a1 = true
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t21 {
  top: 178px;
  text-align: center;
  width: 100%;
}
.t21a {
  bottom: 4vw;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/swiper21.vue